import { styled } from '@mui/material';

import { I18nResources } from '@app-velocity/i18n';
import { BackArrowIcon, CloseIcon } from '@app-velocity/icons';

import { Box } from '../../../Box';
import { useModalContext } from '../../context/useModalContext';
import { Title } from './Title';
import { HeaderWrapper } from './HeaderWrapper';

export type HeaderProps = {
  title?: I18nResources;
  goBack?: () => void;
};

const AbsoluteHeader = styled('header')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  padding: `${theme.spacing(4)} ${theme.spacing(5)}`,
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
}));

const StyledBackButton = styled('button')({
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
});

export const Header = ({ title, goBack }: HeaderProps) => {
  const { closeModal } = useModalContext();

  if (!title && !goBack) {
    return (
      <AbsoluteHeader>
        <Box
          sx={{
            cursor: 'pointer',
            svg: { fill: 'var(--text-text-primary-color)' },
          }}
          data-testid="modal-close-icon"
          onClick={() => closeModal()}
        >
          <CloseIcon />
        </Box>
      </AbsoluteHeader>
    );
  }

  return (
    <HeaderWrapper>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        {goBack && (
          <StyledBackButton onClick={goBack}>
            <BackArrowIcon />
          </StyledBackButton>
        )}
        {title && <Title title={title} />}
      </Box>
      <Box
        sx={{
          cursor: 'pointer',
          svg: { fill: 'var(--text-text-primary-color)' },
        }}
        data-testid="modal-close-icon"
        onClick={() => closeModal()}
      >
        <CloseIcon />
      </Box>
    </HeaderWrapper>
  );
};
